// @ts-nocheck
import _ from 'lodash'

import {
  ADD_JOB_TITLE_FIELD_ERROR,
  ADD_JOB_TITLE_FIELDS_ERRORS,
  CHANGE_JOB_TITLE_FIELD,
  CLEAR_JOB_TITLE_FIELD_ERROR,
  PREDEFINE_JOB_TITLE_FORM_DATA,
  RESET_JOB_TITLE_FORM_DATA,
} from './actions'

const defaultFormData = (predefined = {}) =>
  _.merge(
    {
      id: null,
      name: '',
    },
    predefined,
  )

export const initialState = () => ({
  formData: defaultFormData(),
  errors: {},
})

export default function root(state = initialState(), action) {
  switch (action.type) {
    case CHANGE_JOB_TITLE_FIELD:
      return {
        ...state,
        formData: {
          ...state.formData,
          [action.payload.key]: action.payload.value,
        },
      }

    case ADD_JOB_TITLE_FIELD_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.field]: action.payload.error,
        },
      }

    case ADD_JOB_TITLE_FIELDS_ERRORS:
      return {
        ...state,
        errors: action.payload.errors,
      }

    case CLEAR_JOB_TITLE_FIELD_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.field]: undefined,
        },
      }

    case RESET_JOB_TITLE_FORM_DATA:
      return {
        ...state,
        formData: defaultFormData(),
        errors: {},
      }

    case PREDEFINE_JOB_TITLE_FORM_DATA:
      return {
        ...state,
        formData: defaultFormData(action.payload),
        errors: {},
      }

    default:
      return state
  }
}
